// extracted by mini-css-extract-plugin
export var avatarContainer = "_ec-0";
export var avatarTypingWave = "_ec-i";
export var gray = "_ec-f";
export var green = "_ec-c";
export var icon = "_ec-9";
export var image = "_ec-1";
export var lg = "_ec-6";
export var md = "_ec-5";
export var presenceDot = "_ec-b";
export var red = "_ec-d";
export var sm = "_ec-4";
export var status = "_ec-a";
export var typingDot = "_ec-h";
export var typingPill = "_ec-g";
export var xl = "_ec-7";
export var xs = "_ec-3";
export var xxl = "_ec-8";
export var xxs = "_ec-2";
export var yellow = "_ec-e";